import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../config';

const VerifyOtp = () => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const email = localStorage.getItem('otp_email');

  const submitOtp = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(`${BASE_URL}/api/verify-otp`, {
        email,
        otp
      });

      // ✅ FINAL LOGIN SUCCESS
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('userdata', JSON.stringify(res.data.user));

      Swal.fire('Success', 'Login successful', 'success');
      navigate('/dashboard');

    } catch (err) {
      Swal.fire(
        'Error',
        err?.response?.data?.message || 'OTP verification failed',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginscreen d-flex align-items-center justify-content-center">
      <div className="login-box p-4 shadow text-center">
        <h4 style={{ color: '#fff' }}>Enter OTP</h4>

        <form onSubmit={submitOtp}>
         <input
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  className="form-control mb-3"
  placeholder="Enter 6-digit OTP"
  value={otp}
  maxLength={6}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); // remove non-numbers
    if (value.length <= 6) {
      setOtp(value);
    }
  }}
/>


          <button className="btn btn-primary w-100" disabled={loading}>
            Verify OTP
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyOtp;
